import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

import { logger } from '@gem/modules/logger';

import Entities from 'STORE';

export function useIsBackNavigationHandler(): void {
  const location = useLocation();
  const locationKey = useRef<string>(location.key || '');

  useEffect(() => {
    const handlePopState = async (): Promise<void> => {
      Entities.App.setIsBackPage(true);

      const ongoingCall = Entities.Calls.ongoingCall;
      if (!ongoingCall) {
        return;
      }

      try {
        await ongoingCall.delete();
      } catch (error) {
        logger.get('navigation').error('Failed to delete ongoing call on popstate', error);
      }
    };

    window.addEventListener('popstate', handlePopState);

    return () => {
      window.removeEventListener('popstate', handlePopState);
    };
  }, []);

  useEffect(() => {
    // browser event is trigger before changes from react router
    if (locationKey.current !== location.key) {
      Entities.App.setIsBackPage(false);
      locationKey.current = location.key || '';
    }
  }, [location]);
}
